import { Button, Input, Modal, Spin, Typography } from 'antd'
import Title from 'antd/es/typography/Title';
import React, { useState } from 'react'
import { EmployeeAPI } from '../../API/EmployeeAPI';
import { ADD_EMPLOYEE_INITIAL_OBJECT } from '../../screens/configuration/ConfigurationUtils';
const { Text } = Typography;

export const AddEmployee = ({ open, setOpen, messageToast, loadConfigData }) => {
    const [inputElements, setInputElements] = useState(ADD_EMPLOYEE_INITIAL_OBJECT);
    const [loadSpin, setLoadSpin] = useState(false)

    function addFun() {
        if (inputElements.name.trim() !== "") {
            if (inputElements.name.trim().length < 100) {
                setLoadSpin(true);
                const bodyData = {
                    "name": inputElements.name
                }
                addEmpFun(bodyData)
            }
        } else {
            setInputElements(prev => ({
                ...prev,
                errorFieds: {
                    name: "Name is required"
                }
            }))
        }
    }

    function backFun() {
        setInputElements(ADD_EMPLOYEE_INITIAL_OBJECT)
        setOpen(false)
    }

    async function addEmpFun(bodyData) {
        await EmployeeAPI.addEmploye(bodyData)
            .then(res => {
                if (res.data.status === true) {
                    setOpen(false)
                    setLoadSpin(false)
                    setInputElements(ADD_EMPLOYEE_INITIAL_OBJECT)
                    loadConfigData()
                } else {
                    messageToast('error', res.data?.message);
                    setLoadSpin(false)
                }
            })
            .catch(() => {
                messageToast('error', "Internal Server Error");
                setLoadSpin(false)
            })
    }

    return (
        <Modal
            open={open}
            okText='Apply'
            cancelText='Clear All'
            onCancel={() => backFun()}
            onOk={addFun}
            footer={[
                <Button key="back" type='text' onClick={backFun}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={addFun}
                >
                    Add
                </Button>
            ]}
        >
            <Spin spinning={loadSpin}>
                <div style={{ padding: '10px' }}>
                    <div style={{ marginBottom: '20px', borderBottom: 'solid 1px #80808047' }}>
                        <Title level={5}>Add Employee</Title>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label>Name</label>
                        <Input status={!inputElements.errorFieds.name ? '' : 'error'} value={inputElements.name}
                            onChange={(e) => {
                                const value = e.target.value.trimStart();
                                let error = '';

                                if (value.trim() === '') {
                                    error = 'Name is required';
                                } else if (value.trim().length >= 100) {
                                    error = 'MAX length 100!';
                                }

                                setInputElements((prev) => ({
                                    ...prev,
                                    name: value,
                                    errorFieds: {
                                        name: error
                                    }
                                }));
                            }}
                        />
                        <Text type="danger" italic>{inputElements.errorFieds.name}</Text>
                    </div>
                </div>
            </Spin>
        </Modal>
    )
}
